import React from 'react';

export default function MiniLoader(props) {
  const loaderStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...props.additionalStyles,
  };

  return (
    <div style={loaderStyle}>
      <i
        className={`fas fa-spin fa-circle-notch fa-${
          props.size ? props.size : '2x'
        }`}
      />
    </div>
  );
}

MiniLoader.defaultProps = {
  additionalStyles: {
    minHeight: 200,
  },
};
